import { Injectable } from '@angular/core';
import { PublicApiClientsService } from './integrations-service/publicapiclients-service/publicapiclients.service';
import { ContactsService } from './contacts-service/contacts.service';
import { EventsService } from './events-service/events.service';
import { IntegrationsService } from './integrations-service/integrations.service';
import { InvitationsService } from './invitations-service/invitations.service';
import { CustomFontsService } from './customfonts-service/customfonts.service';
import { ActivityLogsService } from './activitylogs-service/activitylogs.service';
import { UsersService } from './users-service/users.service';
import { AttendeesService } from './attendees-service/attendees.service';
import { UtmTrackingsService } from './utmtrackings-service/utmtrackings.service';
import { ETicketService } from './e-ticket-service/e-ticket.service';
import { FrontdeskLocationsService } from './frontdesk-locations-service/frontdesk-locations.service';
import { GroupsService } from './groups-service/groups.service';
import { SupportConfigsService } from './support-config-service/support-config.service';
import { CampaignsService } from './campaigns-service/campaigns.service';
import { BrandingService } from './branding-service/branding.service';
import { ReportsService } from './reports-service/reports.service';
import { GalleryService } from './gallery-service/gallery.service';
import { EventCustomFieldsService } from './eventcustomfields-service/eventcustomfields.service';
import { TextTemplatesService } from './texttemplates-service/texttemplates.service';
import { ReportQueriesService } from './reportqueries-service/reportqueries.service';
import { RegistrationTokensService } from './registrationtokens-service/registrationtokens.service';
import { NotificationsService } from './notifications-service/notifications.service';
import { NotificationSettingsService } from './notificationsettings-service/notificationsettings.service';
import { MailTrackingSettingsService } from './mailtrackingsettings-service/mailtrackingsettings.service';
import { EventTextTemplatesService } from './eventcustomfields-service copy/eventcustomfields.service';
import { DocumentsService } from './documents-service/documents.service';
import { FootersService } from './footers-service/footers.service';
import { AdvancedTemplatesService } from './advanced-templates-service/advanced-templates.service';
import { TimelinesService } from './timelines-service/timelines.service';
import { PromotionsService } from './promotions-service/promotions.service';
import { DomainsService } from './domains-service/domains.service';
import { SpeakersService } from './speakers-service/speakers.service';
import { WorkshopsService } from './workshops-service/workshops.service';
import { CustomFieldTemplatesService } from './customfieldtemplates-service/customfieldtempates.service';
import { SurveyService } from './survey-service/survey.service';
import { FilecenterService } from './filecenter-service/filecenter.service';
import { TeamsService } from './teams-service/teams.service';
import { ProductsService } from './products-service/products.service';
import { SlugsService } from './slugs-service/slugs.service';
import { GDPRDataPrivacyService } from './gdpr-data-privacy-service/gdpr-data-privacy.service';
import { UserProvisioningsService } from './user-provisionings-service/user-provisionings.service';
import { HalitoService } from './halito-service/halito.service';

@Injectable()
export class DashboardApiService {

  constructor(
    public invitations: InvitationsService,
    public integrations: IntegrationsService,
    public contacts: ContactsService,
    public textTemplates: TextTemplatesService,
    public events: EventsService,
    public activityLogs: ActivityLogsService,
    public publicApiClients: PublicApiClientsService,
    public customFonts: CustomFontsService,
    public users: UsersService,
    public attendees: AttendeesService,
    public utmTrackings: UtmTrackingsService,
    public groups: GroupsService,
    public supportConfigs: SupportConfigsService,
    public campaigns: CampaignsService,
    public frontdeskLocations: FrontdeskLocationsService,
    public eTicket: ETicketService,
    public branding: BrandingService,
    public reports: ReportsService,
    public gallery: GalleryService,
    public eventCustomFields: EventCustomFieldsService,
    public reportQueries: ReportQueriesService,
    public registrationTokens: RegistrationTokensService,
    public notifications: NotificationsService,
    public notificationSettings: NotificationSettingsService,
    public mailTrackingSettings: MailTrackingSettingsService,
    public eventTextTemplates: EventTextTemplatesService,
    public footers: FootersService,
    public advancedTemplates: AdvancedTemplatesService,
    public documentTemplates: DocumentsService,
    public timelines: TimelinesService,
    public promotions: PromotionsService,
    public domains: DomainsService,
    public speakers: SpeakersService,
    public workshops: WorkshopsService,
    public customfieldtemplates: CustomFieldTemplatesService,
    public survey: SurveyService,
    public filecenter: FilecenterService,
    public teams: TeamsService,
    public products: ProductsService,
    public slugs: SlugsService,
    public gdprdataprivacy: GDPRDataPrivacyService,
    public userProvisionings: UserProvisioningsService,
    public halito: HalitoService
  ) { }

}
